import { Accordion, Badge, Box, Flex, Text } from '@workos-inc/design-system';
const EventRoot = (props: React.ComponentPropsWithoutRef<typeof Box>) => <Box className="EventRoot" py="4" {...props} data-sentry-element="Box" data-sentry-component="EventRoot" data-sentry-source-file="event.tsx" />;
interface EventDetailsProps {
  name?: string;
  comingSoon?: boolean;
  children?: React.ReactNode;
}
const EventDetails = ({
  children,
  comingSoon,
  name
}: EventDetailsProps) => <Accordion.Root mt="-1" size="1" data-sentry-element="Accordion.Root" data-sentry-component="EventDetails" data-sentry-source-file="event.tsx">
    <Accordion.Item value="1" data-sentry-element="Accordion.Item" data-sentry-source-file="event.tsx">
      <Accordion.Header as="h4" data-sentry-element="Accordion.Header" data-sentry-source-file="event.tsx">
        <Flex gap="1" data-sentry-element="Flex" data-sentry-source-file="event.tsx">
          <Text size="2" weight="bold" data-sentry-element="Text" data-sentry-source-file="event.tsx">
            {name}
          </Text>
          {comingSoon && <Badge color="gray">
              <Text color="gray" style={{
            lineHeight: 'inherit'
          }}>
                Coming soon
              </Text>
            </Badge>}
        </Flex>
      </Accordion.Header>

      <Accordion.Content data-sentry-element="Accordion.Content" data-sentry-source-file="event.tsx">
        <Box my="-4" data-sentry-element="Box" data-sentry-source-file="event.tsx">{children}</Box>
      </Accordion.Content>
    </Accordion.Item>
  </Accordion.Root>;
interface EventDescriptionProps {
  children?: React.ReactNode;
  comingSoon?: boolean;
}
export const EventDescription = ({
  children,
  ...props
}: EventDescriptionProps) => {
  let description = children;

  // Most of the time MDX wraps text in a paragraph tag,
  // but when it doesn't, we do that ourselves to ensure
  // a consistent DOM structure.
  if (typeof description === 'string') {
    description = <p>{children}</p>;
  }
  return <Text as="div" className="EventDescription" size="2" {...props} data-sentry-element="Text" data-sentry-component="EventDescription" data-sentry-source-file="event.tsx">
      {description}
    </Text>;
};
export const Event = {
  Root: EventRoot,
  Details: EventDetails,
  Description: EventDescription
};